"use client";

import { track } from "@/marketing/analytics";

type CtaProps = {
  href: string;
  location: string;
  className?: string;
  children: React.ReactNode;
};

/** Anchor con tracking de click de CTA genérico (prop `location` para el funnel). */
export function CtaLink({ href, location, className, children }: CtaProps) {
  return (
    <a
      href={href}
      className={className}
      onClick={() => track("landing_cta_click", { location })}
    >
      {children}
    </a>
  );
}

/**
 * CTA de signup/alta. Además del `landing_cta_click` genérico (que NO se
 * rompe), emite un evento propio `landing_signup_click` con `{ location }`
 * para trazar la conversión a alta por evento, sin depender del autocapture
 * por texto del link (el copy de la landing está en reescritura).
 */
export function SignupCta({ href, location, className, children }: CtaProps) {
  return (
    <a
      href={href}
      className={className}
      onClick={() => {
        track("landing_cta_click", { location });
        track("landing_signup_click", { location });
      }}
    >
      {children}
    </a>
  );
}
